import React, { useEffect, useMemo, useState } from 'react';
import supabase from '../../../../supabaseClient';

const WEEKDAY_LABELS = ['PON', 'WT', 'ŚR', 'CZW', 'PT', 'SOB', 'NIE'];
const WEEKDAY_MONDAY_INDEX = (jsDay) => (jsDay + 6) % 7;

function parseISO(s) {
  const [y, m, d] = s.split('-').map(Number);
  return new Date(y, m - 1, d);
}
function toISODate(d) {
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
}

function generateWeekDays(currentDate) {
  const current = parseISO(currentDate);
  const leading = WEEKDAY_MONDAY_INDEX(current.getDay());
  const weekStart = new Date(current.getFullYear(), current.getMonth(), current.getDate() - leading);
  const days = [];
  for (let i = 0; i < 7; i++) {
    const d = new Date(weekStart.getFullYear(), weekStart.getMonth(), weekStart.getDate() + i);
    days.push({ dateISO: toISODate(d), dayNum: d.getDate(), weekdayLabel: WEEKDAY_LABELS[i] });
  }
  return days;
}

async function fetchCalendarEvents(startDate, endDate, idConfig) {
  const { data, error } = await supabase
    .from('calendar_events')
    .select(`
      id, title, event_date, event_time, notes,
      category:calendar_categories ( id, name, color ),
      assigned_profile:profiles!calendar_events_assigned_to_fkey ( id, full_name )
    `)
    .eq('id_configuration', idConfig)
    .gte('event_date', startDate)
    .lte('event_date', endDate)
    .order('event_date', { ascending: true })
    .order('event_time', { ascending: true });
  if (error) throw error;
  return data;
}

function CalendarWeek({ currentDate, filterCategory, filterEmployee, onAddClick,onEventClick, eventsVersion, idConfig }) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  const days = useMemo(() => generateWeekDays(currentDate), [currentDate]);

  useEffect(() => {
    if (!idConfig) return;
    let cancelled = false;
    setLoading(true);
    fetchCalendarEvents(days[0].dateISO, days[6].dateISO, idConfig)
      .then((data) => { if (!cancelled) setEvents(data); })
      .catch((err) => console.error('Błąd pobierania akcji kalendarza:', err))
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [days, eventsVersion, idConfig]);

  const filteredEvents = useMemo(() => events.filter((ev) =>
    (filterCategory === 'ALL' || ev.category?.id === filterCategory) &&
    (filterEmployee === 'ALL' || ev.assigned_profile?.id === filterEmployee)
  ), [events, filterCategory, filterEmployee]);

  const eventsByDate = useMemo(() => filteredEvents.reduce((acc, ev) => {
    (acc[ev.event_date] ||= []).push(ev);
    return acc;
  }, {}), [filteredEvents]);

  const todayISO = new Date().toISOString().slice(0, 10);

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 12 }}>
      {days.map((day) => {
        const isToday = day.dateISO === todayISO;
        const dayEvents = eventsByDate[day.dateISO] || [];
        return (
          <div key={day.dateISO} style={{ background: '#fff', border: '1px solid #eee', borderRadius: 16, minHeight: 220, overflow: 'hidden' }}>
            <div style={{ padding: '10px 12px', borderBottom: '1px solid #f5f0f0', background: isToday ? '#fdf1f1' : '#fafafa' }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: '#705A5E', textTransform: 'uppercase' }}>{day.weekdayLabel}</div>
              <div style={{ fontSize: 18, fontWeight: 800, color: isToday ? '#6B1D2F' : '#2C1419' }}>{day.dayNum}</div>
            </div>
            <div style={{ padding: 8, display: 'flex', flexDirection: 'column', gap: 6 }}>
              {dayEvents.map((ev) => (
                <div
                    key={ev.id}
                    onClick={() => onEventClick?.(ev)}
                    style={{
                    background: (ev.category?.color || '#999') + '17', borderLeft: `3px solid ${ev.category?.color || '#999'}`,
                    borderRadius: 6, padding: '6px 8px', cursor: 'pointer',
                    }}
                >
                    <div style={{ fontSize: 11, fontWeight: 700, color: '#2C1419' }}>{ev.event_time?.slice(0, 5)} · {ev.title}</div>
                    <div style={{ fontSize: 10, color: '#705A5E', marginTop: 2 }}>{ev.assigned_profile?.full_name || '—'}</div>
                </div>
                ))}
              <button onClick={() => onAddClick?.(day.dateISO)} style={addBtnStyle}>+ dodaj</button>
            </div>
          </div>
        );
      })}
      {loading && <div style={{ gridColumn: '1 / -1', padding: 12, fontSize: 12, color: '#705A5E', textAlign: 'center' }}>Ładowanie…</div>}
    </div>
  );
}

export default CalendarWeek;

const addBtnStyle = { background: 'none', border: '1px dashed #e3d9d9', borderRadius: 6, padding: 6, fontSize: 11, color: '#705A5E', cursor: 'pointer' };